import React, { forwardRef, useEffect, useImperativeHandle, useState, useRef } from 'react';
export const MentionList = forwardRef((props, ref) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const listRef = useRef(null);
    const itemRefs = useRef([]);

    const selectItem = (index) => {
        const item = props.items[index];
        if (item) {
            props.command(item);
        }
    };

    const upHandler = () => {
        setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
    };

    const downHandler = () => {
        setSelectedIndex((selectedIndex + 1) % props.items.length);
    };

    const enterHandler = () => {
        selectItem(selectedIndex);
    };

    useEffect(() => {
        setSelectedIndex(0);
    }, [props.items]);

    useEffect(() => {
        if (itemRefs.current[selectedIndex]) {
            itemRefs.current[selectedIndex].scrollIntoView({
                block: 'nearest',
                behavior: 'smooth'
            });
        }
    }, [selectedIndex]);

    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                upHandler();
                return true;
            }
            if (event.key === 'ArrowDown') {
                downHandler();
                return true;
            }
            if (event.key === 'Enter') {
                enterHandler();
                return true;
            }
            return false;
        },
    }));

    return (
        <div
            ref={listRef}
            className="mention-list"
            style={{
                background: '#ffffff',
                border: '1px solid #cbd5e1',
                borderRadius: '8px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                maxHeight: '260px',
                overflowY: 'auto',
                overflowX: 'hidden',
                minWidth: '240px',
                maxWidth: '420px',
                width: 'max-content',
                padding: '4px',
                scrollbarWidth: 'thin',
                scrollbarColor: '#94a3b8 #f8fafc'
            }}
        >
            {props.items.length > 0 ? (
                props.items.map((item, index) => (
                    <button
                        ref={(el) => (itemRefs.current[index] = el)}
                        className={`mention-list-item ${index === selectedIndex ? 'is-selected' : ''}`}
                        key={item.key || item.label || index}
                        onClick={() => selectItem(index)}
                        onMouseEnter={() => setSelectedIndex(index)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            textAlign: 'left',
                            background: index === selectedIndex ? '#f0fdfa' : 'transparent',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: index === selectedIndex ? 600 : 400,
                            color: index === selectedIndex ? '#0f766e' : '#1e293b',
                            transition: 'background-color 0.1s ease, color 0.1s ease',
                            boxSizing: 'border-box'
                        }}
                    >
                        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.35', width: '100%' }}>
                            {item.label || item.key}
                        </span>
                    </button>
                ))
            ) : (
                <div className="mention-list-empty" style={{ padding: '10px 14px', fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                    No variables found
                </div>
            )}
            <style>{`
                .mention-list::-webkit-scrollbar {
                    width: 6px;
                }
                .mention-list::-webkit-scrollbar-track {
                    background: #f8fafc;
                    border-radius: 4px;
                }
                .mention-list::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 4px;
                }
                .mention-list::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }
            `}</style>
        </div>
    );
});
